import React from 'react';
import factory from 'components/Icons/factory';

// Icons are built as 128x128 originals
export const Pencil = factory(
  'Pencil',
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
    <path d="M128.005 20.54l-17.253 17.253-20.506-20.506L107.499.033zM105.095 43.5l-68.943 68.944-20.506-20.506 68.943-68.944zM.052 127.986l2.192-6.859L9.81 97.581l20.506 20.506-30.264 9.9z" />
  </svg>
);

export default Pencil;
